import { Injectable } from "@angular/core";
import { SearchConfigurationModel } from "apps-module/app/entry-modules/charity-search/models/search-configuration.model";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/charity-search/models/form-search-parameters.model";
import { QuerySearchParametersModel } from "apps-module/app/entry-modules/charity-search/models/query-search-parameters.model";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { NumericUtils } from "apps-module/app/shared-library/utils/numeric.utils";
import {SearchFilterOptionModel} from "../models/search-filter-option.model";

@Injectable()
export class FormSearchParametersService {

    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public create(queryString: string, configuration: SearchConfigurationModel): FormSearchParametersModel {
        const rawValues = this._serializationService.deserialize(queryString);

        const formParameters = {
            homePageId: configuration.homePageId,
            pageNumber: NumericUtils.parse(rawValues[nameof<QuerySearchParametersModel>("pageNumber")] as string, 1),
            sortOption: rawValues[nameof<QuerySearchParametersModel>("sortOption")] as string || "Rank;asc",
            searchText: rawValues[nameof<QuerySearchParametersModel>("searchText")] as string || "",
            aooa: rawValues[nameof<QuerySearchParametersModel>("aooa")] as Array<string> || [],
            aoob: rawValues[nameof<QuerySearchParametersModel>("aoob")] as Array<string> || [],
            aood: rawValues[nameof<QuerySearchParametersModel>("aood")] as Array<string> || [],
            classification1: rawValues[nameof<QuerySearchParametersModel>("classification1")] as Array<string> || [],
            classification2: rawValues[nameof<QuerySearchParametersModel>("classification2")] as Array<string> || [],
            classification3: rawValues[nameof<QuerySearchParametersModel>("classification3")] as Array<string> || [],
            income: rawValues[nameof<QuerySearchParametersModel>("income")] as Array<string> || [],
            site: rawValues[nameof<QuerySearchParametersModel>("site")] as Array<string> || [],
            include: rawValues[nameof<QuerySearchParametersModel>("include")] as Array<string> || [],
            orgType: rawValues[nameof<QuerySearchParametersModel>("orgType")] as Array<string> || []
            //  onlyShow: rawValues[nameof<QuerySearchParametersModel>("onlyShow")] as string || ""
        } as FormSearchParametersModel;

        return formParameters;
    }
}
